// Carry Roll Aerodynamic coefficients — PSD §4.2.2. Pure functions.
import { SPIN_DECAY_HALFLIFE, SPIN_FLOOR_RPM } from './constants';
/** Speed-dependent drag coefficient (validated envelope 30–80 m/s). */
export function dragCoeff(speed) {
    return 0.23 + 0.0034 * (speed - 40);
}
/** Magnus lift coefficient from spin rate (rps) and speed. */
export function liftCoeff(spinRps, speed) {
    return (1.2e-4 * spinRps) / Math.max(speed, 1);
}
/** Spin decay: RPM halves roughly every ~5 s. Applied per step. */
export function spinDecay(spinRpm, dt) {
    const decayed = spinRpm * Math.pow(0.5, dt / SPIN_DECAY_HALFLIFE);
    return Math.max(decayed, SPIN_FLOOR_RPM);
}
//# sourceMappingURL=aerodynamics.js.map